/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE: you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { IgrAbsoluteVolumeOscillatorIndicatorModule } from './igr-absolute-volume-oscillator-indicator-module';
import { IgrAccumulationDistributionIndicatorModule } from './igr-accumulation-distribution-indicator-module';
import { IgrAverageDirectionalIndexIndicatorModule } from './igr-average-directional-index-indicator-module';
import { IgrAverageTrueRangeIndicatorModule } from './igr-average-true-range-indicator-module';
import { IgrBollingerBandWidthIndicatorModule } from './igr-bollinger-band-width-indicator-module';
import { IgrChaikinOscillatorIndicatorModule } from './igr-chaikin-oscillator-indicator-module';
import { IgrChaikinVolatilityIndicatorModule } from './igr-chaikin-volatility-indicator-module';
import { IgrCommodityChannelIndexIndicatorModule } from './igr-commodity-channel-index-indicator-module';
import { IgrDetrendedPriceOscillatorIndicatorModule } from './igr-detrended-price-oscillator-indicator-module';
import { IgrEaseOfMovementIndicatorModule } from './igr-ease-of-movement-indicator-module';
import { IgrFastStochasticOscillatorIndicatorModule } from './igr-fast-stochastic-oscillator-indicator-module';
import { IgrForceIndexIndicatorModule } from './igr-force-index-indicator-module';
import { IgrFullStochasticOscillatorIndicatorModule } from './igr-full-stochastic-oscillator-indicator-module';
import { IgrMarketFacilitationIndexIndicatorModule } from './igr-market-facilitation-index-indicator-module';
import { IgrMassIndexIndicatorModule } from './igr-mass-index-indicator-module';
import { IgrMedianPriceIndicatorModule } from './igr-median-price-indicator-module';
import { IgrMoneyFlowIndexIndicatorModule } from './igr-money-flow-index-indicator-module';
import { IgrMovingAverageConvergenceDivergenceIndicatorModule } from './igr-moving-average-convergence-divergence-indicator-module';
import { IgrNegativeVolumeIndexIndicatorModule } from './igr-negative-volume-index-indicator-module';
import { IgrOnBalanceVolumeIndicatorModule } from './igr-on-balance-volume-indicator-module';
import { IgrPercentagePriceOscillatorIndicatorModule } from './igr-percentage-price-oscillator-indicator-module';
import { IgrPercentageVolumeOscillatorIndicatorModule } from './igr-percentage-volume-oscillator-indicator-module';
import { IgrPositiveVolumeIndexIndicatorModule } from './igr-positive-volume-index-indicator-module';
import { IgrPriceVolumeTrendIndicatorModule } from './igr-price-volume-trend-indicator-module';
import { IgrRateOfChangeAndMomentumIndicatorModule } from './igr-rate-of-change-and-momentum-indicator-module';
import { IgrRelativeStrengthIndexIndicatorModule } from './igr-relative-strength-index-indicator-module';
import { IgrSlowStochasticOscillatorIndicatorModule } from './igr-slow-stochastic-oscillator-indicator-module';
import { IgrStandardDeviationIndicatorModule } from './igr-standard-deviation-indicator-module';
import { IgrStochRSIIndicatorModule } from './igr-stoch-rsi-indicator-module';
import { IgrTRIXIndicatorModule } from './igr-trix-indicator-module';
import { IgrTypicalPriceIndicatorModule } from './igr-typical-price-indicator-module';
import { IgrUltimateOscillatorIndicatorModule } from './igr-ultimate-oscillator-indicator-module';
import { IgrWeightedCloseIndicatorModule } from './igr-weighted-close-indicator-module';
import { IgrWilliamsPercentRIndicatorModule } from './igr-williams-percent-r-indicator-module';
import { IgrCustomIndicatorModule } from './igr-custom-indicator-module';
var IgrIndicatorsModule = /** @class */ /*@__PURE__*/ (function () {
    function IgrIndicatorsModule() {
    }
    IgrIndicatorsModule.register = function () {
        IgrAbsoluteVolumeOscillatorIndicatorModule.register();
        IgrAccumulationDistributionIndicatorModule.register();
        IgrAverageDirectionalIndexIndicatorModule.register();
        IgrAverageTrueRangeIndicatorModule.register();
        IgrBollingerBandWidthIndicatorModule.register();
        IgrChaikinOscillatorIndicatorModule.register();
        IgrChaikinVolatilityIndicatorModule.register();
        IgrCommodityChannelIndexIndicatorModule.register();
        IgrDetrendedPriceOscillatorIndicatorModule.register();
        IgrEaseOfMovementIndicatorModule.register();
        IgrFastStochasticOscillatorIndicatorModule.register();
        IgrForceIndexIndicatorModule.register();
        IgrFullStochasticOscillatorIndicatorModule.register();
        IgrMarketFacilitationIndexIndicatorModule.register();
        IgrMassIndexIndicatorModule.register();
        IgrMedianPriceIndicatorModule.register();
        IgrMoneyFlowIndexIndicatorModule.register();
        IgrMovingAverageConvergenceDivergenceIndicatorModule.register();
        IgrNegativeVolumeIndexIndicatorModule.register();
        IgrOnBalanceVolumeIndicatorModule.register();
        IgrPercentagePriceOscillatorIndicatorModule.register();
        IgrPercentageVolumeOscillatorIndicatorModule.register();
        IgrPositiveVolumeIndexIndicatorModule.register();
        IgrPriceVolumeTrendIndicatorModule.register();
        IgrRateOfChangeAndMomentumIndicatorModule.register();
        IgrRelativeStrengthIndexIndicatorModule.register();
        IgrSlowStochasticOscillatorIndicatorModule.register();
        IgrStandardDeviationIndicatorModule.register();
        IgrStochRSIIndicatorModule.register();
        IgrTRIXIndicatorModule.register();
        IgrTypicalPriceIndicatorModule.register();
        IgrUltimateOscillatorIndicatorModule.register();
        IgrWeightedCloseIndicatorModule.register();
        IgrWilliamsPercentRIndicatorModule.register();
        IgrCustomIndicatorModule.register();
    };
    return IgrIndicatorsModule;
}());
export { IgrIndicatorsModule };
